import { render, staticRenderFns } from "./ProductDetailDescription.vue?vue&type=template&id=50176a6a"
import script from "./ProductDetailDescription.vue?vue&type=script&lang=js"
export * from "./ProductDetailDescription.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailDescription.vue?vue&type=style&index=0&id=50176a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports